import React from "react";
import Snackbar, { SnackbarProps } from "@material-ui/core/Snackbar";
import { SnackbarContent } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import { color } from "style/constants";
import { NotificationBody, NotificationCard, NotificationTitle } from "./styled";

interface CustomProps {
  description?: string;
  close(): void;
  status: "error" | "info" | "success" | "dismissed";
  title?: string;
}

const StyledSnackbarContent = styled(({ notifierColor, childrens, ...otherProps }) => (
  <SnackbarContent {...otherProps}>{childrens}</SnackbarContent>
))`
  && {
    border-left: 10px solid ${props => props.notifierColor};
  }
`;

type NotifierProps = CustomProps & SnackbarProps;

const Notifier: React.FC<NotifierProps> = ({
  description,
  open,
  close,
  status,
  title
}: NotifierProps) => {
  const notifierColor = {
    error: color.DARKRED,
    info: color.BLUE,
    success: color.GREEN,
    dismissed: color.GRAY
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      autoHideDuration={5000}
      onClose={() => {
        close();
      }}
      open={open}
    >
      <StyledSnackbarContent
        notifierColor={notifierColor[status]}
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={() => {
              close();
            }}
          >
            <CloseIcon />
          </IconButton>
        ]}
        message={
          <NotificationCard>
            <NotificationTitle>{title}</NotificationTitle>
            <NotificationBody>{description}</NotificationBody>
          </NotificationCard>
        }
      />
    </Snackbar>
  );
};

export default Notifier;
